import React from "react";
import { observer } from "mobx-react";
import { BotRunViewStore } from "../../store";
import { BotRunViewForm } from "./BotRunViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type BotRunViewProps = {
  botRunViewStore: BotRunViewStore;
};

export const BotRunView: React.FC<BotRunViewProps> = observer(
  ({ botRunViewStore }) => {
    return (
      <div>
        <BotRunViewForm
          botTypeOptions={botRunViewStore.getBotTypeOptions()}
          botType={botRunViewStore.botTypeValue}
          runNumber={botRunViewStore.runNumberValue}
          status={botRunViewStore.statusValue}
          currentPhase={botRunViewStore.currentPhaseValue}
          startedAt={botRunViewStore.startedAtValue}
          completedAt={botRunViewStore.completedAtValue}
          duration={botRunViewStore.durationValue}
          params={botRunViewStore.paramsValue}
          result={botRunViewStore.resultValue}
          error={botRunViewStore.errorValue}
          correlationId={botRunViewStore.correlationIdValue}
          totalPhases={botRunViewStore.totalPhasesValue}
          completedPhases={botRunViewStore.completedPhasesValue}
          requiresHumanIntervention={
            botRunViewStore.requiresHumanInterventionValue
          }
          interventionReason={botRunViewStore.interventionReasonValue}
          logsPath={botRunViewStore.logsPathValue}
          workerEventValue={botRunViewStore.workerEventValue}
          triggeredByValue={botRunViewStore.triggeredByValue}
          relatedEntityType={botRunViewStore.relatedEntityTypeValue}
          relatedEntityId={botRunViewStore.relatedEntityIdValue}
          relatedEntityLabel={botRunViewStore.relatedEntityLabelValue}
          cancellationRequestedAt={botRunViewStore.cancellationRequestedAtValue}
          cancellationRequestedByValue={
            botRunViewStore.cancellationRequestedByValue
          }
          cancellationReason={botRunViewStore.cancellationReasonValue}
          phasesVisibleColumns={botRunViewStore.phasesVisibleColumns}
          phasesSetColumnWiths={(x) => botRunViewStore.phasesSetColumnWiths(x)}
          phasesRows={botRunViewStore.phasesRowsDyn}
          errorsVisibleColumns={botRunViewStore.errorsVisibleColumns}
          errorsSetColumnWiths={(x) => botRunViewStore.errorsSetColumnWiths(x)}
          errorsRows={botRunViewStore.errorsRowsDyn}
          onPrint={(handlePrint: () => void) =>
            botRunViewStore.printBotRun(handlePrint)
          }
          onCancel={() => botRunViewStore.cancelBotRun()}
          onEdit={
            botRunViewStore.isEditEnabled
              ? () => botRunViewStore.editBotRun()
              : undefined
          }
        />
        <ErrorDialog
          open={botRunViewStore.errorDialogOpened}
          title={botRunViewStore.errorTitle}
          description={botRunViewStore.errorDescription}
          onClose={() => botRunViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
